import { Container, Box, Typography, Card, Grid, CardContent, CardHeader, CardActions, Button, Avatar } from "@mui/material";
import servicetop from '../../assets/servicetop.png';
import custsoft from '../../assets/customersoftware.png';
import crm from '../../assets/crm.png';
import bps from '../../assets/bps.png';
import powerapp from '../../assets/powerapp.png';
import softcons from '../../assets/softwareconsult.png';
import softtest from '../../assets/softwaretesting.png';
import webd from '../../assets/webdev.png';
import appintegration from '../../assets/appintegration.png';
import rpa from '../../assets/rpa.png';
import SecondSlider from "../../component/horizontalslider";
import './index.css'
const ServicePage = () => {
    const data = [
        { image: custsoft, title: "Custom Software Development", text: "Tailored Solutions for Unique Needs", path: "/#" },
        { image: softcons, title: "Software Consulting", text: "Expert Guidance for Your Digital Journey", path: "/#" },
        { image: webd, title: "Security", text: "Protecting Your Digital Assets", path: "/#" },
        { image: powerapp, title: "Artificial Intelligence", text: "Transforming Insights into Intelligence", path: "/#p" },
        { image: rpa, title: "Robotic Process Automation", text: "Streamlining Operations with Automation", path: "/#" },
        { image: bps, title: "Business Process Services", text: "Optimizing Your Processes for Success", path: "/#s" },
    ];
    const workflow = [
        { image: custsoft, title: "Initial Consultation", text: "We begin by listening to your unique business needs and goals." },
        { image: softcons, title: "Design & Development", text: "Our team crafts a customized IT strategy that aligns with your vision." },
        { image: webd, title: "Testing & Quality Assurance", text: " Rigorous testing ensures a flawless and high-quality product." },
        { image: powerapp, title: "Implementation", text: " Our experts seamlessly integrate your solution into your existing operations." },
        { image: rpa, title: "Monitoring & Optimization", text: " We continuously monitor performance and make necessary adjustments for optimal results.", },
        { image: bps, title: "Reporting & Support", text: "Our dedicated support team provides ongoing assistance and regular performance reports." },


    ];
    
    return (
        <Container maxWidth={false} sx={{ paddingTop: "10px", }}>
            <SecondSlider  />
            <Container style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', marginTop: '50px', marginBottom: "50px", justifyContent: 'space-between' }}>
                <Grid container spacing={5}>
                    <Grid item xs={12} md={6} lg={6} >
                        <Typography
                            variant='h4'
                            style={{
                                color: "#0B77A8",
                                fontFamily: "Poppins, sans-serif",
                                fontWeight: "600",
                                marginRight: '40px', // Space between the title and the paragraph
                                marginLeft: '0', // Remove left margin or adjust as needed
                                textAlign: 'left', // Align text to the left
                                whiteSpace: 'nowrap', // Prevent the text from wrapping to a new line
                                overflow: 'hidden', // Hide overflow text
                                textOverflow: 'ellipsis' // Add ellipsis for overflow text if needed
                            }}
                        >
                            Innovative Solutions
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography component='p' className="poppins-regular"
                            sx={{
                                fontSize: {
                                    lg: "1.5rem",
                                    md: "1.0rem",
                                    sm: "1.2rem",
                                    xs: "0.7rem"


                                },
                                color: "#5A5959",

                                lineHeight: "1.5",
                                flex: 1, // Allow the paragraph to take up remaining space
                                textAlign: 'left', // Align text to the left for the paragraph
                                margin: '0', // Remove default margins to better align with the heading
                                // minHeight: '5em',
                                marginLeft: "30px"
                            }}
                        >
                            At Edgology , we specialize in providing tailored solutions that drive business success. Our services range from Custom Software Development to expert Software Consulting, ensuring your technology aligns with your goals.
                            We focus on enhancing efficiency through Robotic Process Automation and Artificial Intelligence, while prioritizing security to protect your digital assets. Our Business Process Services streamline operations, allowing you to concentrate on growth and innovation.
                        </Typography>
                    </Grid>

                </Grid>
            </Container>
            <Grid container spacing={4} sx={{ padding: "50px 30px 50px 30px", backgroundColor: "#ffe8e8" }}>
                {data.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card
                            sx={{
                                display: 'flex',
                                flexDirection: 'column', // Makes sure the content stacks vertically
                                justifyContent: 'space-between', // Ensures the content and button are spaced
                                height: {
                                    lg: '100%',
                                    md: '245px',
                                    sm: '250px',
                                },
                            }}
                        >
                            <CardContent sx={{ flexGrow: 1 }}> {/* Allows the content to grow and push the button down */}
                                <Avatar
                                    src={item.image}
                                />
                                <Typography
                                    component="p"
                                    variant="h6"
                                    className="poppins-semibold"
                                    sx={{ marginTop: '10px', color: 'black' }}
                                >
                                    {item.title}
                                </Typography>
                                <Typography
                                    component="p"
                                    className="poppins-regular"
                                    sx={{ marginTop: '5px', color: 'gray' }}
                                >
                                    {item.text}
                                </Typography>
                            </CardContent>
                            <CardActions> {/* Centering the button */}
                                <Button size="small" variant="contained" color="primary">
                                    Learn More
                                </Button>
                            </CardActions>
                        </Card>

                    </Grid>
                ))}
            </Grid>
            <Grid container spacing={4} style={{ paddingTop: "50px" ,paddingBottom:"50px"}}>


                <Box style={{ width: '55%', padding: '0 50px 0px 50px' }}> {/* Box to control width */}
                    <Typography variant="h3" style={{ color: "#0B77A8", textAlign: 'left' }} sx={{
                        fontsize: {
                            xl: "2.5rem",
                            lg: "2rem",
                            md: "2rem",
                            sm: "1.5rem",
                            xs: "2rem"
                        }
                    }} className='poppins-semibold'>
                        Our Process WorkFlow
                    </Typography>
                </Box>
                {workflow.map((item, index) => (
                    <Grid item xs={6} sx={{ paddingTop: "5px" }}>
                        <Box mt={4} style={{ paddingLeft: "30px", textAlign: 'left', display: "flex", borderRadius: "15px", backgroundColor: "white", marginTop: "5px" }}>
                            <Avatar src={item.image} style={{ marginRight: "10px" }}>
                                {/* <FontAwesomeIcon icon={faMicrochip} /> Use the imported icon object */}
                            </Avatar>
                            <div>
                                <Typography variant="h5" className='poppins-semibold' gutterBottom sx={{
                                    fontSize: {
                                        xl: "1rem", // Extra large screens
                                        lg: "1rem",   // Large screens
                                        md: "1.2rem", // Medium screens
                                        sm: "1.2rem",   // Small screens
                                        xs: "1rem"  // Extra small screens
                                    }
                                }} style={{ display: "flex", alignItems: "center" }}>

                                    {item.title}
                                </Typography>

                                <Typography variant="body1" gutterBottom className='poppins-regular' sx={{
                                    fontSize: {
                                        xl: "0.8rem", // Extra large screens
                                        lg: "0.71rem",   // Large screens
                                        md: "0.9rem", // Medium screens
                                        sm: "0.7rem",   // Small screens
                                        xs: "0.8rem"  // Extra small screens
                                    }
                                }}>
                                    {item.text}
                                </Typography>
                            </div>
                        </Box>
                    </Grid>
                ))}

            </Grid>


        </Container>


    );
};

export default ServicePage;
